import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  useProjectDescriptionHook,
  useProjectImageHook,
} from '@/hooks/projectHook';
import { PATH } from '@/utils/constant';
import Markdown from '@common/markdown';
import styles from '@layout/layout.module.css';

const StyledArticle = styled.div`
  --gap: 2rem;
  display: flex;
  flex-direction: column;
  gap: var(--gap);

  & > div:first-child {
    margin: 1rem 0 0.5rem 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    & > * {
      margin: 0.5rem;
      display: inline;
    }
  }

  & > div:last-child {
    margin: 2rem;
    display: flex;
    justify-content: center;
  }

  & > .imageArea {
    text-align: center;
    width: 100%;

    & div {
      max-width: 100%;
      width: ${(props) => props.$img?.width}px;
      height: 0;
      padding-bottom: ${(props) =>
        (props.$img?.height / props.$img?.width) * 100}%;
    }

    & img {
      max-width: 100%;
    }
  }
`;

const ImageArea = (props) => {
  const imageHook = useProjectImageHook(props.filename);
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => {
    setLoading(false);
  };

  return (
    <div className="imageArea">
      {loading && (
        <div className={styles.skeleton}>
          <div />
        </div>
      )}
      {imageHook.loadDone && (
        <img
          src={imageHook.data}
          alt={props.filename}
          onLoad={handleImageLoad}
          style={{ display: loading ? 'none' : 'inline' }}
        />
      )}
    </div>
  );
};

const ProjectDetailSection = ({ title, project }) => {
  const { t } = useTranslation();
  const descriptionHook = useProjectDescriptionHook(title);
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(PATH.intro);
  };

  return (
    descriptionHook.loadDone && (
      <StyledArticle $img={project.img}>
        <div>
          <h1>{t('project_title', { title })}</h1>
          <h3>{`${project.period.start} ~ ${
            project.period.end ?? `(${t('in_progress')})`
          }`}</h3>
        </div>
        {project.img && <ImageArea {...project.img} />}
        <Markdown>{descriptionHook.data}</Markdown>
        <div>
          <button className="common" onClick={handleClick}>
            {t('btn_go_main')}
          </button>
        </div>
      </StyledArticle>
    )
  );
};

export default ProjectDetailSection;
